var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{style:({height: `${_vm.height}px`}),attrs:{"colspan":_vm.colspan}})])
}
var staticRenderFns = []

export { render, staticRenderFns }